module.exports = __webpack_public_path__ + "img/e7ab4c2.svg";